module.exports = __webpack_public_path__ + "dcc75eb554d38fb334cd95c8d021ef23.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_3_0.woff
// module id = 538
// module chunks = 0